<div class="content-list-search-result-view" id="searchResultViews">
  @if (searchContainer.searching) {
    <div class="content-list-search-result-view__spinner-container">
      <div class="content-list-search-result-view__spinner-content">
        <mat-spinner
          color="accent"
          diameter="30"
        ></mat-spinner>

        <p>
          {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
        </p>
      </div>
    </div>
  }
  @else {
    @if (searchContainer?.searchResult) {
      <div>
        @if (searchContainer.searchResult.search_count === 0) {
          <div>
            <h1>
              {{ 'TRANS__SEARCH_RESULT__NO_SEARCH_HITS' | translate }}
            </h1>
          </div>
        }
        @else if (searchContainer.searchResult.search_count > 0) {
          <div>
            @if (contentListContainer.resultViewName === 'list') {
              <app-content-list-field-templates
                #fieldTemplates
                [searchContainer]="searchContainer"
                [reloadOverview]="reloadOverview"
              ></app-content-list-field-templates>
              <app-search-result-view-list
                [searchContainer]="searchContainer"
                [stableColumns]="true"
                [framed]="true"
                [fieldTemplateContainer]="fieldTemplates.operationContainer"
                [fieldOperationGroupId]="fieldTemplates.groupId"
              ></app-search-result-view-list>
            } @else {
              <app-object-content-list-regular-items
                [contentListContainer]="contentListContainer"
                [hasOperationMenu]="!!contentListContainer && !!contentListContainer.operationContainer"
                (objectRefresh)="onObjectRefresh($event)"
              ></app-object-content-list-regular-items>
            }
          </div>
        }
      </div>
    }
  }
</div>
